import { AgGridColumnDef, AgGridOptions } from '@tassat/common-definitions';
import { AddressBookRecord } from '@tassat/fred-definitions';

import { IFeaturesContext } from 'SharedComponents/hooks/useFeatures';

export const getAddressBookColumnDefs: (features: IFeaturesContext, onContactFavoriteChange:
(data: AddressBookRecord) => unknown) => AgGridColumnDef[] = (features: IFeaturesContext, onContactFavoriteChange) => {
    const defaultColumnDefs: AgGridColumnDef[] = [
        {
            field: 'AccountName',
            headerName: 'Account Name',
            cellRenderer: 'walletNameCellRenderer',
            menuTabs: [],
            minWidth: 200,
            flex: 4
        },
        {
            field: 'Account',
            headerName: 'Lynq Account Address',
            cellRenderer: 'walletAddressCellRenderer',
            cellRendererParams: { isAdmin: false },
            cellClass: 'cellStyleClass',
            menuTabs: [],
            minWidth: 250,
            flex: 5
        },
        {
            field: 'AssociatedAccountNumber',
            headerName: 'Associated Account Number',
            menuTabs: [],
            minWidth: 250,
            flex: 5
        },
        {
            field: 'UpdatedAt',
            headerName: 'Last Updated',
            cellRenderer: 'dateCellRenderer',
            cellClass: 'cellStyleClass',
            menuTabs: [],
            minWidth: 150,
            maxWidth: 200,
            flex: 3
        },
        {
            field: 'ModifiedByUsername',
            headerName: 'Modified By',
            cellClass: 'cellStyleClass',
            menuTabs: [],
            minWidth: 150,
            flex: 3
        },
        {
            field: 'IsFavorite',
            headerName: 'Favorites',
            cellClass: 'cellStyleClass',
            cellRenderer: 'isFavoriteCellRenderer',
            cellRendererParams: { onContactFavoriteChange },
            menuTabs: [],
            minWidth: 100,
            maxWidth: 175,
            resizable: false,
            suppressMovable: true,
            flex: 2
        },
        {
            field: 'Actions',
            headerName: 'Actions',
            headerClass: 'rightAligned',
            width: 100,
            cellRenderer: 'actionButtonsCellRenderer',
            cellRendererParams: {
                actionButtonOptions: {
                    hasDelete: true,
                    hasEdit: true
                }
            },
            menuTabs: [],
            resizable: false,
            suppressMovable: true
        }
    ];

    return defaultColumnDefs;
};

export const AddressBookGridOptions: AgGridOptions = {
    rowHeight: 70,
    rowStyle: { borderTop: 'solid 5px #f5f5f5' }
};